import { Form, Input } from "antd";
import { useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ContainerForm } from "../styles";
import { Leads } from "../../../interfaces/Leads";
import { validarDados } from "../utils/validadores";

interface FormData {
  setFormData: (data: Partial<Leads>) => void;
  formData: Partial<Leads>;
  onValidChange: (isValid: boolean) => void;
}

/**
 * Formulário para coleta de dados do usuário.
 */
export default function FormDados({
  setFormData,
  formData,
  onValidChange,
}: FormData) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData);
    }
  }, [formData, form]);

  const handleChange = (_: Partial<Leads>, allValues: Partial<Leads>) => {
    const isValid = validarDados(allValues);

    onValidChange(isValid);
    if (isValid) {
      setFormData(allValues);
    }
  };

  return (
    <ContainerForm>
      <Form
        form={form}
        name="form-dados"
        layout="vertical"
        autoComplete="off"
        onValuesChange={handleChange}
        style={{ maxWidth: 600 }}
      >
        <Form.Item
          name="nome"
          label="Nome"
          className="formItems"
          hasFeedback
          validateTrigger="onBlur"
          rules={[
            { required: true, message: "O nome é obrigatório" },
            {
              min: 3,
              message: "O nome deve ter no mínimo 3 caracteres",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="celular"
          label="Celular"
          className="formItems"
          rules={[{ required: true, message: "O celular é obrigatório" }]}
        >
          <PhoneInput
            country="br"
            onChange={(value) => form.setFieldsValue({ celular: value })}
            placeholder="Digite o número do seu celular"
            inputClass="phone-input"
          />
        </Form.Item>
      </Form>
    </ContainerForm>
  );
}
